<ng-container *ngIf="registerForm">
  <div [formGroup]="registerForm">
    <div class="text-center" style="margin-bottom: 20px">
      <h2 translate>components.signInModalComponent.sobreTi</h2>
      <p translate>components.signInModalComponent.configuracion</p>
    </div>

    <div class="content-modal">
      <div class="form-d">
        <label translate>components.signInModalComponent.queQuieresHacer</label>
        <div class="group-type">
          <ng-container *ngFor="let item of userTypes">
            <div
              class="btn-type"
              [ngClass]="{
                'btn-type-active': userTypeSelected == item.id_user_type,
              }"
              (click)="selectType.emit(item)"
            >
              {{
                translateService.getCurrentLang() === "es"
                  ? item.description
                  : item.description_en
              }}
            </div>
          </ng-container>
        </div>
      </div>

      <div class="form-d mt-4">
        <label translate
          >components.signInModalComponent.telefonoContacto</label
        >
        <div class="group-type">
          <app-countries-autocomplete
            [control]="registerForm.get('code_country')"
          ></app-countries-autocomplete>
          <input
            type="text"
            appMaxLength
            [maxLength]="10"
            class="form-control"
            formControlName="phone"
            id="phone_number"
          />
        </div>
      </div>

      <!-- <div class="input-inv">
      <mat-checkbox
        (change)="onRegisterTypeChange.emit()"
        color="primary"
        formControlName="factory"
      >
        <span translate>
          components.signInModalComponent.representarEmpresa</span
        >
      </mat-checkbox>
    </div> -->

      <ng-container *ngIf="registerForm.get('factory')?.value === true">
        <div class="input-inv">
          <label for="company_name" translate
            >components.signInModalComponent.nombreEmpresa</label
          >
          <input
            class="form-control"
            id="company_name"
            formControlName="company_name"
          />
        </div>
      </ng-container>

      <div class="input-inv">
        <mat-checkbox color="primary" formControlName="legal">
          <span translate>
            components.signInModalComponent.recibirInformacion</span
          >
        </mat-checkbox>
      </div>

      @if (userTypeSelected === 3) {
        <button
          type="button"
          (click)="submit.emit()"
          [disabled]="!canContinue"
          class="submit-btn"
        >
          {{ "components.signInModalComponent.finalizar" | translate }}
        </button>
      } @else {
        <button
          type="button"
          (click)="goToStep.emit(isSeller ? 7 : 3)"
          [disabled]="!canContinue"
          class="submit-btn"
        >
          {{ "components.signInModalComponent.empezar" | translate }}
        </button>
      }
    </div>
  </div>
</ng-container>
